import { ChartConfiguration, ChartType } from 'chart.js';

export function buildChartTheme<
  T extends ChartType,
>(): ChartConfiguration<T>['options'] {
  const styles = getComputedStyle(document.body);

  const textColor = styles.getPropertyValue('--theme-text').trim() || '#666';

  const gridColor =
    styles.getPropertyValue('--theme-border').trim() || '#e1e4e8';

  const surfaceColor =
    styles.getPropertyValue('--theme-surface').trim() || '#ffffff';

  return {
    responsive: true,
    maintainAspectRatio: false,

    scales: {
      x: {
        type: 'category',

        grid: {
          color: gridColor,
          display: true,
        },

        ticks: {
          autoSkip: false,
          maxRotation: 90,
          minRotation: 0,
          color: textColor,

          font: {
            size: 10,
          },
        },

        title: {
          color: textColor,
        },
      },

      y: {
        type: 'linear',

        beginAtZero: true,

        grid: {
          color: gridColor,
          display: true,
        },

        ticks: {
          color: textColor,
        },

        title: {
          color: textColor,
        },
      },
    },

    plugins: {
      legend: {
        labels: {
          color: textColor,
        },
      },

      tooltip: {
        titleColor: textColor,
        bodyColor: textColor,
        backgroundColor: surfaceColor,
        borderColor: gridColor,
        borderWidth: 1,
      },
    },
  } as ChartConfiguration<T>['options'];
}
